import React from 'react';
import { Card, Tab, Tabs, Spinner, Alert, Row, Col, Badge } from 'react-bootstrap';
import { FaShieldAlt, FaChartLine, FaDatabase, FaClock } from 'react-icons/fa';
import CaliDashboard from './CaliDashboard';

/**
 * Componente para el sistema de auditoría y métricas
 */
const SistemaAudit = ({
  sistemaAuditTab,
  setSistemaAuditTab,
  metricasSistema,
  loadingMetricas,
  onRecargarMetricas,
  usuario
}) => {
  return (
    <Card className="mt-4">
      <Card.Header>
        <div className="d-flex align-items-center">
          <FaShieldAlt className="me-2" />
          <span>Sistema de Auditoría y Escalabilidad - FASE 4</span>
        </div>
      </Card.Header>
      <Card.Body>
        <CaliDashboard usuario={usuario} />
      </Card.Body>
    </Card>
  );
};

export default SistemaAudit;